import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=ad865f94&scoped=true&"
import script from "./EmailDetail.vue?vue&type=script&lang=js&"
export * from "./EmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=ad865f94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad865f94",
  null
  
)

export default component.exports